<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  export let onclick = () => {};
  export let size = "large";
  export let text = "";
  export let style = "";

  let cls = "";
  export { cls as class };
</script>

<Button kind="upgrade" {size} {onclick} class={cls} {style}>{text}</Button>
